import React from "react";

const NoCopyText = ({ children }) => {
  const handleContextMenu = (event) => {
    event.preventDefault(); // Prevent right-click context menu
  };

  const handleCopy = (event) => {
    event.preventDefault(); // Prevent copy operation
  };

  return (
    <div
      onContextMenu={handleContextMenu}
      onCopy={handleCopy}
      style={{
        userSelect: "none", // Disable text selection
        WebkitUserSelect: "none", // For Safari
        MozUserSelect: "none", // For Firefox
        msUserSelect: "none", // For IE and Edge
      }}
    >
      {children}
    </div>
  );
};

export default NoCopyText;
